import { Component, OnInit } from '@angular/core';
import { PlatformService } from "services/platform.service";

declare global {
	interface Window {
		dataLayer:any;
	}
}

@Component({
	selector: 'ras-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit {
	title = 'Rent-a-Store';
	first_run = true

	ngOnInit() {
	}

	onActivate(event) {
		if (this.platform.isBrowser) {
			window.scrollTo(0, 0)

			if (this.first_run) {
				this.first_run = false
				console.debug("Initial page load", window.location.pathname, "dataLayer", window.dataLayer.length);
			}
			else window.setTimeout(() => {
				window.dataLayer = window.dataLayer || []
				window.dataLayer.push({
					event: 'page_view',
					page: {
						path: window.location.pathname,
						title: document.title
					}
				});
			}, 1)
		}
	}

	constructor(private platform: PlatformService) { }
}
